export const isProfileComplete = (status) => {
  return status.profile_complete || !status.profile_required;
};